import InviteWizardVM from './invites/wizard-vm';
import CourseListingVM from '../course/listing/listing-vm';

class AdminDashboardModule {
  constructor() {
    const validationOptions = {
      insertMessages: false,
      errorsAsTitle: true,
      decorateInputElement: true,
      parseInputAttributes: true,
      messagesOnModified: true,
      errorElementClass: 'error',
      errorMessageClass: 'error',
      decorateElementOnModified: true,
      decorateElement: true,
      grouping: { deep: true, observable: true, live: true }
    }

    if (document.getElementById('dashboard_json')) {
      const dashboardData = JSON.parse(document.getElementById('dashboard_json').value)

      ko.applyBindingsWithValidation(
        new CourseListingVM(dashboardData, 'AdminDashboard'),
        document.getElementById('admin_course_listing'),
        validationOptions
      )

      ko.applyBindingsWithValidation(
        new InviteWizardVM(dashboardData),
        document.getElementById('instructor_invites'),
        validationOptions
      )
    }
  }
}

export default new AdminDashboardModule();
